module.exports = __webpack_public_path__ + "static/img/数据智能体_bj@2x.e30176f6.png";